// Routes getters

import { ServiceTypeEnum } from "../features/GoService/enum/service.enum";
import APP_ROUTES from "./routeConstants";

type Id = string | number;

// Profiles
export const getPlayerProfileRoute = (userId: Id) => `/player/${userId}`;
export const getPlayerTrophiesRoute = (userId: Id) => `/player/${userId}/trophies`;
export const getCoachProfileRoute = (userId: Id) => `/coach/${userId}`;
export const getAgentProfileRoute = (userId: Id) => `/agent/${userId}`;
export const getScoutProfileRoute = (userId: Id) => `/scout/${userId}`;
export const getOtherProfileRoute = (userId: Id) => `/other/${userId}`;
export const getEntityProfileRoute = (entityId: Id, tab?: string) => `/entity/${entityId}${tab ? `?tab=${tab}` : ""}`;
export const getProfileRoute = (id: Id, role: string) => `/${role.toLowerCase()}/${id}`;
export const getEntityAchievementsRoute = (entityId: Id, achievementId: Id) =>
  `/entity/${entityId}/achievements/${achievementId}`;
export const getEntityProfileEditRoute = (entityId: Id, tab?: string) =>
  `/entity/${entityId}/edit${tab ? `?tab=${tab}` : ""}`;
export const getPersonaTestimonialsRoute = (persona: string, userId: Id) => `/${persona}/${userId}/testimonials`;
export const getAllServicesRoute = (persona: string, userId: Id, entityId?: Id) =>
  `/${persona}/${entityId || userId}/all-services${entityId ? `?userId=${userId}` : ""}`;
export const getAllReviewsRoute = (persona: string, userId: Id, entityId?: Id) =>
  `/${persona}/${entityId || userId}/all-reviews${entityId ? `?userId=${userId}` : ""}`;
export const getEntityProfileEditBranchRoute = (entityId: Id, branchId: Id) =>
  `/entity/${entityId}/edit/branch/${branchId}`;
export const getEntityProfileBranchRoute = (entityId: Id, branchId: Id) => `/entity/${entityId}/branch/${branchId}`;

// GoHire
export const getServicePageRoute = (serviceId: Id, type: string) =>
  `/go-hire/${type === ServiceTypeEnum.OneTime ? "service" : "program"}/${serviceId}`;
export const getServiceReviewsPageRoute = (serviceId: Id) => `/go-hire/service/${serviceId}/reviews`;
export const getServiceRequestPageRoute = (serviceRequestId: Id, tab?: "details" | "chat" | "contract") =>
  `/go-hire/service-request/${serviceRequestId}${tab ? `?tab=${tab}` : ""}`;
// export const getProgramRequestPageRoute = (programRequestId: Id) => `/go-hire/program-request/${programRequestId}`;
export const getProgramVideoPageRoute = (serviceId: Id, videoId: Id) =>
  `/go-hire/program/${serviceId}/video/${videoId}`;
export const getCreateContractRoute = (requestId: Id, serviceId: Id) =>
  `/go-hire/create-contract/${requestId}/${serviceId}`;
export const getOverviewServicesRoute = () => `/go-hire/overview-services`;
export const getGoHireRoute = () => `/go-hire/jobs`;
export const getCreateJobRoute = () => `/go-hire/create-job`;
export const getCreateJobRouteWithJobType = (jobType: "talent" | "professional") =>
  `/go-hire/create-job?jobType=${jobType}`;
export const getJobDetailsRoute = (jobId: Id) => `/go-hire/jobs/${jobId}`;
export const getCreateServiceRoute = (type?: "service" | "program") =>
  `${APP_ROUTES.CREATE_SERVICE}${type ? `?type=${type}` : ""}`;
export const getCandidateDetailsRoute = (jobId: Id, candidateId: Id) =>
  `/go-hire/jobs/${jobId}/candidates/${candidateId}`;
export const getCandidateGinoFitScoreRoute = (jobId: Id, candidateId: Id) =>
  `/go-hire/jobs/${jobId}/candidates/${candidateId}/gino-fit-score`;
export const getCandidateReportRoute = (jobId: Id, candidateId: Id, reviewId: Id) =>
  `/go-hire/jobs/${jobId}/candidates/${candidateId}/review/${reviewId}`;

// Events
export const getEventsRoute = () => `/explore/events`;
export const getEventRoute = (eventId: Id) => `/explore/events/${eventId}`;
export const getCreateEventTypeRoute = (eventType: string) => `/explore/events/create/${eventType}`;

// Groups
export const getGroupRoute = (groupId: Id) => `/entity/group/${groupId}`;
export const getEntityGroupCreateRoute = (entityId: Id) => `/entity/${entityId}/groups/create`;
export const getEntityGroupDetailsRoute = (entityId: Id, groupId: Id) => `/entity/${entityId}/groups/${groupId}`;

// Search
export const getSearchValueRoute = (value: string) => `/search?value=${value}`;
export const getSearchTypeUserValueRoute = (value: string) => `/search?type=users&value=${value}`;
export const getSearchTypeEntityValueRoute = (value: string) => `/search?type=entities&value=${value}`;

// Chat
export const getChatThreadRoute = (threadId?: string, selectedReceiverId?: number) =>
  `/chat/${threadId}/${selectedReceiverId}`;

// GoStar
export const getGoStarRoute = (query?: string) => `/explore/go-star/${query ?? ""}`;

export const normalizePath = (path: string) => path.replace(/\/+$/, "");

export const isCurrentRoute = (currentPath: string, targetPath: string) =>
  normalizePath(currentPath) === normalizePath(targetPath);

// global navigate function to be used within interceptors
let navigate: (path: string) => void;

export const setNavigate = (navFn: (path: string) => void) => (navigate = navFn);

export const navigateTo = (path: string) => {
  if (navigate) navigate(path);
};

// Network
export const getNetworkRoute = (tab?: "following" | "followers") => `${APP_ROUTES.NETWORK}${tab && `?tab=${tab}`}`;

export const getEditPostRoute = (postId: Id) => `/feed/edit-post/${postId}`;
export const openFullScreenPostModal = (postId: Id) => `/feed?type=BASIC&type=EVENT&postId=${postId}`;

// GINO
export const getGinoHomeRoute = () => `/gino/home`;

export const getGinoChatRoute = (
  about?: "player" | "professional" | "trainingPlan" | "nutritionPlan" | "trialPrepTryout"
) => `/gino/chat${about ? `?about=${about}` : ""}`;
export const getGinoChatRoomHistoryRoute = (chatId: Id) => `/gino/chat-history/${chatId}`;

export const getGinoSearchResultsRoute = (searchParams?: string) =>
  `/gino/search-results${searchParams ? `?${searchParams}` : ""}`;

export const getPlansRoute = (billing?: "monthly" | "yearly") =>
  `${APP_ROUTES.PLANS}${billing ? `?billing=${billing}` : ""}`;

export const getPlansOverviewRoute = () => APP_ROUTES.PLANS_OVERVIEW;
